
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PolicyLinks = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-center space-x-4">
      <button 
        onClick={() => navigate('/policy')} 
        className="text-white underline hover:text-blue-200"
      >
        Terms and Conditions
      </button>
      <button 
        onClick={() => navigate('/privacy')} 
        className="text-white underline hover:text-blue-200"
      >
        Privacy Policy
      </button>
    </div>
  );
};

export default PolicyLinks;
